<template>
    <BootstrapModal
      ref="modal"
      modalId="deleteTemplateModal"
      title="Confirm Template Deletion"
      closeText="Cancel"
      :confirmText=getConfirmButton()
      :hideConfirmButton="getConfirmButton() != 'Confirm'"
      isDeleteConfirmation
      :deleteMessage="deleteMessage"
      @confirm="handleConfirm"
    />
  </template>
  
  <script>
  import BootstrapModal from "@/components/Common/BootstrapModal.vue";
  import templateService from "@/services/templateService.js";
  import emitter from "@/eventBus";
  
  export default {
    name: "DeleteTemplateModal",
    components: { BootstrapModal },
    props: {
      template: {
        type: Object,
        required: false,
        default: null,
      },
    },
    emits: ["deleted"],
    computed: {
      deleteMessage() {
        if (!this.template) {
            return null;
        }

        return this.template.active_devices_count
          ? `This template is currently in use by a device and cannot be deleted while active.`
          : `Are you sure you want to delete template <b>#${this.template.id} (${this.template.name})</b>?<br>
              <span class="text-secondary small">This action is irreversible.</span>`;
      },
    },
    methods: {
      show() {
        this.$refs.modal.show();
      },
      hide() {
        this.$refs.modal.hide();
      },
      getConfirmButton() {
        return this.template?.active_devices_count ? false : 'Confirm'
      },
      async handleConfirm() {
        if (!this.template?.id) return;
  
        try {
          await templateService.deleteTemplate(this.template.id);
          emitter.emit("show-toast", {
            message: `Template #${this.template.id} deleted successfully.`,
            type: "success",
          });
          this.$emit("deleted", this.template.id);
        } catch (error) {
          console.error(error);
        }
  
        this.hide();
      },
    },
  };
  </script>
  